var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTinderlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-77.80065 -30.774 674.2723 184.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(.92257 1.08393)",
    y2: 113.524,
    y1: -0.041,
    x2: 0.248,
    x1: 113.813,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7854",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD267D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 49.6C55 41.5 59 20.4 56 1c0-.7.6-1.2 1.2-1C79.7 11 105 35 105 71c0 27.6-21.4 52-52.5 52a50 50 0 01-28.2-92.7c.6-.4 1.4 0 1.4.7.3 3.7 1.3 13 5.4 18.6z",
    fill: "url(#a)",
    transform: "translate(-.229 .044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.971 101.144l1.7-2 5.3 16.8-.7.7c-4 3.7-10 5.6-17.7 5.6h-.3c-7 0-12.5-2-16.3-5.7-3.8-3.8-5.8-9.5-5.8-16.7v-45.8h-13.5v-18.5h13.5v-22.3h20.8v22.3h16.5v18.5h-16.6v41.3c0 1.9.5 8 6.3 8 3 0 5.8-1.1 6.8-2.3zm11 19.2v-84.7h20.8v84.7zm10.3-119.3a12.5 12.5 0 11-12.5 12.6c0-6.8 5.7-12.6 12.5-12.6zm66.4 32.5c18 0 27.9 9.8 27.9 27.7v59h-20.8v-54c-.4-9.6-5-14-14.8-14-8.8 0-15.9 5.4-19.5 10v58h-20.8v-84.5h20.8v9c6-5.8 15.6-11 27.2-11zm97.1 10.9v-39.8h20.8v115.8h-20.8v-8.8a34.3 34.3 0 01-24.7 10.7c-22.7 0-37.9-17.8-37.9-44.3 0-26.6 15.2-44.4 37.9-44.4a34 34 0 0124.7 10.8zm0 17.9a25.6 25.6 0 00-19.6-10c-12.9 0-21.5 10.3-21.5 25.7 0 15.3 8.6 25.6 21.5 25.6 7.5 0 15.7-4 19.6-9.8zm69.4-28.7c24.6 0 41.7 19 41.7 46v5.7h-62.9c2.1 11.9 11.5 19.5 24.3 19.5 8.1 0 17-3.5 22.1-8.6l1.4-1.2 9.9 14.2-1 .9a48.6 48.6 0 01-34.1 12.2c-26 0-44.3-18.3-44.3-44.4a42.8 42.8 0 0143-44.3zm-21.3 36h42.7c-1.2-12.7-11.7-18.5-21.4-18.5-14.6 0-20.1 11-21.3 18.6zm113.3-36h1.5v21l-1.8-.3c-1.5-.3-3.4-.5-5.3-.5-6.7 0-16 4.7-19.5 9.7v56.7h-20.8v-84.6h20.9v9.4c6.9-7.2 16-11.4 25-11.4z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinderlogo);
export default __webpack_public_path__ + "static/media/tinderlogo.c24b2d12888040ffe6ecb77adab8acca.svg";
export { ForwardRef as ReactComponent };